export interface BankItem {
    code: string;
    name: string;
    bin: string;
    logo: string;
}

export const BANK_LIST: BankItem[] = [
    { code: 'VCB', name: 'Vietcombank', bin: '970436', logo: 'assets/img/bank-logo/vcb.png' },
    { code: 'TCB', name: 'Techcombank', bin: '970407', logo: 'assets/img/bank-logo/tech.png' },
    { code: 'BIDV', name: 'BIDV', bin: '970418', logo: 'assets/img/bank-logo/BIDV.png' },
    { code: 'VTB', name: 'VietinBank', bin: '970415', logo: 'assets/img/bank-logo/vtb.png' },
    { code: 'VPB', name: 'VPBank', bin: '970432', logo: 'assets/img/bank-logo/vpbank.png' },
    { code: 'ACB', name: 'ACB', bin: '970416', logo: 'assets/img/bank-logo/acb.png' },
    { code: 'MB', name: 'MB Bank', bin: '970422', logo: 'assets/img/bank-logo/mb.png' },
    { code: 'TPB', name: 'TPBank', bin: '970423', logo: 'assets/img/bank-logo/tpbank.png' },
    { code: 'STB', name: 'Sacombank', bin: '970403', logo: 'assets/img/bank-logo/scb.png' },
    { code: 'SHB', name: 'SHB', bin: '970443', logo: 'assets/img/bank-logo/shb.png' },
    { code: 'VIB', name: 'VIB', bin: '970441', logo: 'assets/img/bank-logo/vib.png' },
    { code: 'OCB', name: 'OCB', bin: '970448', logo: 'assets/img/bank-logo/ocb.png' },
    { code: 'MSB', name: 'MSB', bin: '970426', logo: 'assets/img/bank-logo/msb.png' },
    { code: 'LPB', name: 'LPBank', bin: '970449', logo: 'assets/img/bank-logo/lpbank.png' },
    { code: 'SEAB', name: 'SeABank', bin: '970440', logo: 'assets/img/bank-logo/sea.png' },
];

export const BANK_FULL_NAME_MAP: Record<string, string> = {
    VCB: 'Ngân hàng TMCP Ngoại thương Việt Nam',
    TCB: 'Ngân hàng TMCP Kỹ thương Việt Nam',
    BIDV: 'Ngân hàng TMCP Đầu tư và Phát triển Việt Nam',
    VTB: 'Ngân hàng TMCP Công thương Việt Nam',
    VPB: 'Ngân hàng TMCP Việt Nam Thịnh Vượng',
    ACB: 'Ngân hàng TMCP Á Châu',
    MB: 'Ngân hàng TMCP Quân đội',
    TPB: 'Ngân hàng TMCP Tiên Phong',
    STB: 'Ngân hàng TMCP Sài Gòn Thương Tín',
    SHB: 'Ngân hàng TMCP Sài Gòn - Hà Nội',
    VIB: 'Ngân hàng TMCP Quốc tế Việt Nam',
    OCB: 'Ngân hàng TMCP Phương Đông',
    MSB: 'Ngân hàng TMCP Hàng Hải Việt Nam',
    LPB: 'Ngân hàng TMCP Lộc Phát Việt Nam',
    SEAB: 'Ngân hàng TMCP Đông Nam Á',
};
